import { useEffect, useState } from "react";
import { useGlobalContext } from "../../Context/Authentation";
import axios from 'axios'
import { toast } from 'react-toastify';
import { useParams } from "react-router-dom";

export default function SingleNotePage() {
    const { user, setDeleteModalTitle, setUpdateModalTitle, setUpdateModalcontent, setNoteId, refresh } = useGlobalContext();
    const [data, setdata] = useState();
    const params = useParams();

    const fetchSingleNote = async () => {
        try {
            const config = { headers: { Authorization: `Bearer ${user?.token}` } }
            const { data } = await axios.get(`https://quick-notes-c09v.onrender.com/api/notes/Singlenote/${params.id}`, config);
            setdata(data);

        } catch (error) {
            console.log(error);
            toast.error('Unable to fetch Note', {
                position: "bottom-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
        }
    }


    useEffect(() => {
        user?.token && fetchSingleNote()
        // setDeleteModalTitle(data?.title)
        setUpdateModalTitle(data?.title)
        setUpdateModalcontent(data?.content)
        // eslint-disable-next-line 
    }, [params.id, user?.token])

    useEffect(() => {
        fetchSingleNote()
        // eslint-disable-next-line 
    }, [refresh])

    const DeleteclickHndler = () => {
        setDeleteModalTitle(data?.title)
        setNoteId(data?._id)
    }

    const UpdateclickHndler = (e) => {
        setUpdateModalTitle(data?.title)
        setUpdateModalcontent(data?.content)
        setNoteId(data?._id)
    }

    return (
        <>
            {data ?
                <div style={{
                    padding: "20px", marginBottom: "calc(50vh - 170px)"
                }}>
                    <h3 className="text">{data?.title}</h3>
                    <hr />
                    <p className="text SinglePagrNoteContainer">{data?.content}</p>

                    <div
                        style={{
                            position: "absolute",
                            // bottom: "5px",
                            right: "10px"
                        }}
                    >
                        <i className="bi bi-pencil-square"
                            data-bs-toggle="modal" data-bs-target="#UpdateNotes" style={{ cursor: "pointer", fontSize: "30px", color: "blue" }}
                            onClick={UpdateclickHndler}></i>

                        &nbsp; &nbsp;

                        <i className="bi bi-trash3"
                            data-bs-toggle="modal" data-bs-target="#deleteNotes" style={{ cursor: "pointer", fontSize: "30px", color: "red" }}
                            onClick={DeleteclickHndler}></i>
                    </div>

                </div >
                : <div className="text-center " style={{ height: "calc(100vh - 220px)" }}>
                    <div style={{ height: "100%", width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>

                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            }
        </>

    )
}
